<div  *ngFor="let queue of queues" class="mb-4">
  <p-card header="{{queue.name}}">
    <div class="flex gap-2 flex-wrap">
      <div *ngFor="let member of getQueueMembers(queue)" class="processor">
        <div class="flex align-items-center gap-2">
          <div>
            <img src="/assets/images/no-user-image.png" class="user-image">
          </div>
          <div>
            <b>{{ member.name }}</b><br>
            <div class="mb-1 flex align-items-center gap-1">
              <div pTooltip="RTL: {{ member.rtl }}ms" [class.text-success]="member.rtl<100" [class.text-warning]="member.rtl>=100" [class.text-danger]="member.rtl>=200 || member.rtl == null" class="flex align-items-center">
                <i class="pi pi-wifi"></i>
                <span>{{ member.sipExtension }}</span>
              </div>
              <span class="ml-2 text-danger" *ngIf="member.paused=='1'">(sin llamadas)</span>
            </div>
            <p-badge [value]="member.status" [severity]="member.severity"></p-badge>
          </div>
        </div>
      </div>
      <div *ngIf="getQueueMembers(queue).length==0">La cola esta vacía</div>
    </div>
  </p-card>
</div>